module.exports = __webpack_public_path__ + "static/img/IMG_20160224_125553.01799b3f.jpg";